export const SET_SUNBED_ORDER_STATE_MODAL_EVENT = 'modal:orders:set-sunbed-order-state';
export const SET_SUNBED_ORDER_STATE_MODAL_OPEN = `${SET_SUNBED_ORDER_STATE_MODAL_EVENT}:open`;
export const SET_SUNBED_ORDER_STATE_MODAL_CLOSE = `${SET_SUNBED_ORDER_STATE_MODAL_EVENT}:close`;
